module.exports = __webpack_public_path__ + "static/media/18.9c506d89.png";